import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/box-icn-question.png'
import _imports_1 from '@/assets/images/icn-arrow-right.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-5b477426")

_pushScopeId("data-v-5b477426")
const _hoisted_1 = { class: "fridgedoormonitor-page" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "fridgedoormonitor-page-pushsetting-image" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "fridgedoormonitor-page-pushsetting-image-image",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "fridgedoormonitor-page-pushsetting-title" }
const _hoisted_4 = { class: "fridgedoormonitor-page-pushsetting-title-text" }
const _hoisted_5 = { class: "fridgedoormonitor-page-pushsetting-setting" }
const _hoisted_6 = { class: "fridgedoormonitor-page-pushsetting-setting-text" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "fridgedoormonitor-page-pushsetting-leftarrow" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "fridgedoormonitor-page-pushsetting-leftarrow-image",
    src: _imports_1
  })
], -1)
const _hoisted_8 = { class: "fridgedoormonitor-page-changedailyweekly" }
const _hoisted_9 = {
  class: "fridgedoormonitor-page-content",
  ref: "scroll"
}
const _hoisted_10 = { class: "fridgedoormonitor-page-content-content" }
const _hoisted_11 = { class: "fridgedoormonitor-page-content-content-daily" }
const _hoisted_12 = { class: "fridgedoormonitor-page-content-content-weekly" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsSelectButtons = _resolveComponent("FridgeDetailsSelectButtons")
  const _component_FridgeDoorMonitorDaily = _resolveComponent("FridgeDoorMonitorDaily")
  const _component_FridgeDoorMonitorWeekly = _resolveComponent("FridgeDoorMonitorWeekly")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.pushSettingsValue)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "fridgedoormonitor-page-pushsetting",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickPushSetting(...args)))
        }, [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.pushSettingsTitle), 1)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.pushSettingsValue), 1)
          ]),
          _hoisted_7
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_FridgeDetailsSelectButtons, {
        key: _ctx.updateDisplayKey,
        select: _ctx.selectDailyWeekly,
        onSelectDaily: _ctx.selectDaily,
        onSelectWeekly: _ctx.selectWeekly
      }, null, 8, ["select", "onSelectDaily", "onSelectWeekly"])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_FridgeDoorMonitorDaily, {
            key: _ctx.updateDisplayKey,
            initialIndex: _ctx.initialDailyTabIndex,
            list: _ctx.dailyList,
            onClickDooralarm: _ctx.displayDoorAlarm,
            onChangeDaily: _ctx.changeDailyIndex
          }, null, 8, ["initialIndex", "list", "onClickDooralarm", "onChangeDaily"])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_FridgeDoorMonitorWeekly, {
            key: _ctx.updateDisplayKey,
            list: _ctx.weeklyList,
            onClickDooralarm: _ctx.displayDoorAlarm
          }, null, 8, ["list", "onClickDooralarm"])
        ])
      ])
    ], 512),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowDoorAlarm,
      dialogType: _ctx.doorAlarmType,
      title: _ctx.doorAlarmTitle,
      message: _ctx.doorAlarmMessage,
      negativeLabel: _ctx.doorAlarmOKButtonTitle,
      onNegativeClick: _ctx.doorAlarmOKHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "negativeLabel", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowNotificationAlert,
      dialogType: _ctx.notificationAlertType,
      title: _ctx.notificationAlertTitle,
      message: _ctx.notificationAlertMessage,
      negativeLabel: _ctx.notificationAlertNegativeButtonTitle,
      onNegativeClick: _ctx.notificationAlertNegativeButtonHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "negativeLabel", "onNegativeClick"])
  ]))
})